// pendingChatPromptVar target for the Roles and Competencies Ask AI sidebar.
export const rolesAndCompetenciesAskAiTarget = "roles-and-competencies";

export const roleFrameworkPrompt = (competencyLabel: string) =>
  `/build-role-framework:platform:build-role-framework Help me build or extend our role and ${competencyLabel} framework. Interview me about our people's work, help define roles and expectations, and then help assign employees to roles. Preview each stage for my approval before saving.`;

export const roleFrameworkChatUrl = (competencyLabel: string) =>
  `/ask-ai?${new URLSearchParams({
    p: roleFrameworkPrompt(competencyLabel),
    autosubmit: "1",
  })}`;
